import { RouteConfig } from 'vue-router';
import RatingsApp from '@/apps/ratings/RatingsApp.vue';
import SitterRating from '@/apps/ratings/SitterRating.vue';
import ExternalReviews from '@/apps/ratings/external/ExternalReviews.vue';
import ExternalReviewForm from '@/apps/ratings/external/ExternalReviewForm.vue';
import EmailVerification from '@/apps/ratings/external/EmailVerification.vue';
import { requireSeeker } from '@/router/guards/authGuards';
import externalReviewGuard from '@/router/guards/externalReviewGuard';

const ratingsRoutes: RouteConfig[] = [
  {
    path: '/ratings/sitters/:sitterId',
    component: RatingsApp,
    props: true,
    children: [
      {
        path: 'new',
        name: 'newRating',
        component: SitterRating,
        beforeEnter: requireSeeker,
      },
    ],
  },
  {
    path: '/ratings/sitters/:sitterId/new_external/:reviewToken',
    component: ExternalReviews,
    props: true,
    beforeEnter: externalReviewGuard,
    children: [
      {
        path: '',
        name: 'externalReviewForm',
        component: ExternalReviewForm,
      },
      {
        path: 'verify_email/:emailVerificationToken',
        name: 'externalReviewEmailVerification',
        component: EmailVerification,
      },
    ],
  },
];

export default ratingsRoutes;
